const config = {
  apiSettings: {
    root: window.wpAiWorkflowsSettings?.root || '',
    nonce: window.wpAiWorkflowsSettings?.nonce || ''
  }
};

export default config;